"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreSimpleGrid = _interopRequireDefault(require("@vfuk/core-simple-grid"));
var _coreAnimate = _interopRequireDefault(require("@vfuk/core-animate"));
var _coreMatchMedia = require("@vfuk/core-match-media");
var _coreIconButton = _interopRequireDefault(require("@vfuk/core-icon-button"));
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/SideNavigation.style"));
var _SideNavigationList = _interopRequireDefault(require("./components/SideNavigationList"));
var _SideNavigationSecondaryList = _interopRequireDefault(require("./components/SideNavigationSecondaryList"));
var _constants = require("../../constants");
var _focusOnElement = _interopRequireDefault(require("../../helpers/focusOnElement"));
var _forwardNavigation = _interopRequireDefault(require("../../helpers/forwardNavigation"));
var _backwardNavigation = _interopRequireDefault(require("../../helpers/backwardNavigation"));
var _TopNavigationContext = _interopRequireDefault(require("../../context/TopNavigationContext"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var SideNavigation = function SideNavigation(_ref) {
  var dataSelectorPrefix = _ref.dataSelectorPrefix;
  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
    sm = _useBreakpoints.sm,
    md = _useBreakpoints.md,
    mdAndAbove = _useBreakpoints.mdAndAbove,
    lgAndAbove = _useBreakpoints.lgAndAbove;
  var _ref2 = (0, _react.useContext)(_TopNavigationContext["default"]),
    activeNav = _ref2.activeNav,
    setActiveNav = _ref2.setActiveNav,
    navLevel = _ref2.navLevel,
    setNavLevel = _ref2.setNavLevel,
    activeSubNav = _ref2.activeSubNav,
    setActiveSubNav = _ref2.setActiveSubNav,
    topNavHeight = _ref2.topNavHeight,
    animationDuration = _ref2.animationDuration,
    sideNavigationCloseButton = _ref2.sideNavigationCloseButton,
    navTree = _ref2.navTree,
    setNavTree = _ref2.setNavTree,
    isTransitioning = _ref2.isTransitioning,
    setIsTransitioning = _ref2.setIsTransitioning,
    zIndex = _ref2.zIndex,
    interactionHandler = _ref2.interactionHandler,
    appearance = _ref2.appearance,
    topNavigationTheme = _ref2.topNavigationTheme;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    activeLinkId = _useState2[0],
    setActiveLinkId = _useState2[1];
  var handlePrimaryClick = function handlePrimaryClick(link) {
    if (sm) {
      (0, _forwardNavigation["default"])(link, setIsTransitioning, setNavLevel, setActiveNav, setNavTree, animationDuration, navTree, 1, activeNav);
      return;
    }
    setActiveLinkId(link.id);
    (0, _forwardNavigation["default"])(link, setIsTransitioning, setNavLevel, setActiveSubNav, setNavTree, animationDuration, navTree, 1, activeNav);
  };
  var handleSecondaryClick = function handleSecondaryClick(link) {
    (0, _forwardNavigation["default"])(link, setIsTransitioning, setNavLevel, setActiveSubNav, setNavTree, animationDuration, navTree, navLevel);
  };
  var handleBackClick = function handleBackClick() {
    if (sm) {
      (0, _backwardNavigation["default"])(navLevel, navTree, setIsTransitioning, setNavLevel, setActiveNav, setNavTree, animationDuration);
      return;
    }
    (0, _backwardNavigation["default"])(navLevel, navTree, setIsTransitioning, setNavLevel, setActiveSubNav, setNavTree, animationDuration);
  };
  var handleCloseButtonClick = function handleCloseButtonClick(event) {
    interactionHandler(event, _constants.DataKeys.CloseButton);
    setNavLevel(1);
    (0, _focusOnElement["default"])(activeNav.parentId);
    if (navLevel > 1) {
      setTimeout(function () {
        setNavLevel(0);
      }, animationDuration);
      return;
    }
    setNavLevel(0);
  };
  var closeButtonAppearance = topNavigationTheme.appearance[appearance].sideTray.closeButtonAppearance;
  return /*#__PURE__*/_react["default"].createElement(Styled.SideNavigation, {
    topOffset: topNavHeight,
    zIndex: zIndex,
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, /*#__PURE__*/_react["default"].createElement(Styled.Container, null, /*#__PURE__*/_react["default"].createElement(_coreSimpleGrid["default"], {
    layout: {
      sm: [12],
      md: [5, 5],
      lg: [1, 5, 3]
    },
    verticalAlign: "stretch"
  }, lgAndAbove && /*#__PURE__*/_react["default"].createElement(Styled.Spacer, null), /*#__PURE__*/_react["default"].createElement(Styled.PrimaryNavContainer, {
    zIndex: zIndex,
    appearance: appearance,
    topNavigationTheme: topNavigationTheme
  }, /*#__PURE__*/_react["default"].createElement(Styled.NavContents, {
    animationDuration: animationDuration,
    isTransitioning: sm ? isTransitioning : false
  }, /*#__PURE__*/_react["default"].createElement(_SideNavigationList["default"], {
    backLinkClick: handleBackClick,
    links: activeNav.links,
    onClick: handlePrimaryClick,
    activeLinkId: activeLinkId,
    navLevel: sm ? navLevel : 1,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'list')
  })), (sm && navLevel === 1 || mdAndAbove) && /*#__PURE__*/_react["default"].createElement(_SideNavigationSecondaryList["default"], {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'secondary-list')
  })), mdAndAbove && /*#__PURE__*/_react["default"].createElement(_coreAnimate["default"], {
    show: navLevel > 1,
    enter: {
      animations: ['slideFromLeft'],
      duration: animationDuration
    },
    exit: {
      animations: ['slideToLeft'],
      duration: animationDuration
    }
  }, activeSubNav && /*#__PURE__*/_react["default"].createElement(Styled.SecondaryNavContainer, {
    zIndex: zIndex,
    appearance: appearance,
    topNavigationTheme: topNavigationTheme
  }, /*#__PURE__*/_react["default"].createElement(Styled.NavContents, {
    animationDuration: animationDuration,
    isTransitioning: isTransitioning
  }, /*#__PURE__*/_react["default"].createElement(_SideNavigationList["default"], {
    backLinkClick: handleBackClick,
    links: activeSubNav.links,
    onClick: handleSecondaryClick,
    navLevel: navLevel,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'list')
  }))))), /*#__PURE__*/_react["default"].createElement(Styled.CloseButton, {
    closeButtonPosition: navLevel,
    animationDuration: animationDuration,
    zIndex: zIndex
  }, /*#__PURE__*/_react["default"].createElement(_coreIconButton["default"], {
    id: sideNavigationCloseButton.id,
    icon: {
      name: 'close'
    },
    appearance: closeButtonAppearance,
    size: 4,
    srText: sideNavigationCloseButton.srText,
    onClick: handleCloseButtonClick,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, _constants.DataKeys.CloseButton)
  }))));
};
SideNavigation.displayName = "SideNavigation";
var _default = /*#__PURE__*/(0, _react.memo)(SideNavigation);
exports["default"] = _default;